import React, { act, useEffect, useState } from 'react';
import { arrayRemove, arrayUnion, collection, doc, documentId, onSnapshot, query, setDoc, updateDoc, where } from 'firebase/firestore';
import { db } from '../firebase';
import ArrowBack from '../components/arrowBack';
import { Link } from 'react-router-dom';
import User from '../components/user';
import WhatsApp from '../components/whatsApp';
import Document from "../components/document";
import Gala from '../components/gala';
import ArchiveUser from '../components/archiveUser';

export default function Archives({isToogle}) {

  const [users, setUsers] = useState("")
  const [groups, setGroups] = useState("")
  const [locations, setLocations] = useState("")

  useEffect(() => {

    let data = []
    const getUsers = onSnapshot(collection(db, "users"), (snapshot) => {
      data = (snapshot.docs.map((doc) => (doc.data())));

      let clients = []
      for(let i = 0; i < data?.length; i++) {
        for (let x = 0; x < Object?.keys(data[i]?.subUsers)?.length; x++) {
          clients.push({uid: data[i]?.uid, acc: data[i], user: Object?.values(data[i]?.subUsers)[x]})
        }
      }
      setUsers(clients);

    });
  }, []);

  const weekDayConvert = (day) => {
    if (day === 1) return "Poniedziałek"
    if (day === 2) return "Wtorek"
    if (day === 3) return "Środa"
    if (day === 4) return "Czwartek"
    if (day === 5) return "Piątek"
    if (day === 6) return "Sobota"
  }

useEffect(() => {
  const EXCLUDE_IDS = ["SPdqELFz2ovWSn8eFyws"]; // ten środkowy z obrazka

  const colRef = collection(db, "groups");
  const q = EXCLUDE_IDS.length
    ? query(colRef, where(documentId(), "not-in", EXCLUDE_IDS))
    : colRef;

  const unsub = onSnapshot(q, (snapshot) => {
    const g = snapshot.docs
      // (opcjonalnie podwójny bezpiecznik)
      .filter((doc) => !EXCLUDE_IDS.includes(doc.id))
      .flatMap((doc) => Object.values(doc.data() ?? {}));

    setGroups(g);
  });

  return () => unsub();
}, []);

  useEffect(() => {
    let data = [];
    const getLocations = onSnapshot(collection(db, "locations"), (snapshot) => {
      // Pobieranie danych z snapshot
      data = snapshot.docs.map((doc) => doc.data());
  
      // Połączenie danych w jedną tablicę
      let l = [];
      data.forEach((location) => {
        l.push(...Object.values(location)); // Zakładamy, że dane są obiektem
      });
  
      // Ustawianie stanu grup
      setLocations(l);
    });
  
    // Czyszczenie subskrypcji onSnapshot
    return () => getLocations();
  }, []);

  const verifyAcc = (u) => {
    setDoc(doc(db, "users", u?.uid), {
      subUsers: {
        [u?.user?.index]: {
          docs: {
            contract: {
              groups: u?.user?.groups?.length,
              price: 0,
              type: "standard"
            },
          },
          toVerificate: false
        }
      }
    }, {merge: true})
  }

  const [searcher, setSearcher] = useState("")
  const [filter, setFilter] = useState("")
  const [actualGroup, setActualGroup] = useState("")

  const userList = () => {
    if (!users) return 
    
    // let filtered = users?.filter(x => x?.user?.prices ? Object?.values(x?.user?.prices)?.includes("entry") : "") 
    let filtered = users
    let verify = users?.filter(x => x?.user?.toVerificate === true)

    if (searcher) {
      const srch = searcher.toUpperCase();
      filtered = filtered?.filter(u =>
        u?.user?.displayName?.toUpperCase()?.includes(srch) ||
        u?.acc?.parent?.displayName?.toUpperCase()?.includes(srch) ||
        u?.acc?.email?.toUpperCase()?.includes(srch) ||
        u?.acc?.uid?.toUpperCase()?.includes(srch) ||
        u?.acc?.parent?.phone?.toUpperCase()?.includes(srch) ||
        u?.user?.pesel?.toUpperCase()?.includes(srch) ||
        u?.user?.dateOfBirth?.toUpperCase()?.includes(srch)
      );
    }

    else if (filter?.whatsapp) {
      filtered = filtered?.filter(u => 
        filter?.whatsapp === "empty" ? 
          u?.user?.whatsApp === "" || u?.user?.whatsApp === undefined
          :
          u?.user?.whatsApp === filter?.whatsapp
      )
    }

    else if (filter?.gala) {
      if (actualGroup) {
        filtered = filtered?.filter(u =>
          u?.user?.groups?.includes(actualGroup))?.filter(u => 
          filter?.gala === "empty" ? 
            u?.user?.gala === "" || u?.user?.gala === undefined
            :
            u?.user?.gala === filter?.gala
        )
      }
      else {
        filtered = filtered?.filter(u => 
          filter?.gala === "empty" ? 
            u?.user?.gala === "" || u?.user?.gala === undefined
            :
            u?.user?.gala === filter?.gala
        )
      }
    }

    else if (filter?.noDocs === true) {
      filtered = filtered?.filter(u => 
          u?.acc?.sign === "" || u?.acc?.sign === undefined
      )
    }

    else if (actualGroup) {
      filtered = filtered?.filter(u =>
        u?.user?.groups?.includes(actualGroup)
      );
    }
  

    filtered = filtered?.sort((a, b) => {
      const nameA = a?.user?.displayName?.toUpperCase() || "";
      const nameB = b?.user?.displayName?.toUpperCase() || "";
      return nameA.localeCompare(nameB);
    });

    // && users?.filter(x => x?.user?.groups?.length > 0)

    // filtered = filtered?.filter(x => x?.user?.toVerificate === true)
  
    // return filtered?.map(u => <><User key={u.id} u={u} /> <button onClick={() => verifyAcc(u)}>Weryfikuj</button></>);
      
    return filtered?.map(u => <><ArchiveUser key={u.id} u={u} locations={locations} groups={groups}/></>);
    // return verify?.map(u => <><User key={u.id} u={u} locations={locations} groups={groups}/> <button onClick={() => verifyAcc(u)}>Weryfikuj</button></>);
  };

  function numberToPolishWeekday(num) {
    const days = {
      1: "Poniedziałek",
      2: "Wtorek",
      3: "Środa",
      4: "Czwartek",
      5: "Piątek",
      6: "Sobota",
      7: "Niedziela"
    };
    
    return days[num] || "Niepoprawny numer dnia (1–7)";
  }

    const LOCATION_CITY_MAP = {
      "uoZPbWvIVvdSxpva0WPz": "Jastrzębie",
      "iF6i7m2BBWZKRmN5Fbh5": "Oława",
    };
  
      const cityCounts = React.useMemo(() => {
      if (!users || !groups) return {};
  
      // indeks grup po id (żeby było szybko)
      const groupIndex = new Map((groups || []).map(g => [g?.id, g]));
  
      const counts = {};
      users.forEach(({ user }) => {
        const citiesForUser = new Set();
  
        (user?.groups || []).forEach(gid => {
          const grp = groupIndex.get(gid);
          const locId = grp?.location_id;
          if (!locId) return;
  
          const city = LOCATION_CITY_MAP[locId] || "Wrocław"; // fallback -> Wrocław
          citiesForUser.add(city);
        });
  
        // jeden subUser liczony max raz w danym mieście (ale może być w kilku miastach)
        citiesForUser.forEach(city => {
          counts[city] = (counts[city] || 0) + 1;
        });
      });
  
      return counts;
    }, [users, groups]);

    return (
      <div className={isToogle ? "side-toogle-margin" : "side-margin"} style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column", minHeight: "100vh", overflowY: "scroll", gap: "15px", paddingTop: "20px", paddingBottom: "20px"})}>
        <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", gap: "20px"})}>
        <div style={({display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", position: "relative", width: "100%", gap: '5px', maxWidth: "800px"})}>
          <div className="mobile-column" style={({display: "flex", justifyContent: "center", alignItems: "center", position: "relative", width: "100%", gap: '5px'})}>
            <div style={({display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", position: "relative", width: "60%", maxWidth: "480px"})}>
              <input value={searcher} type="text" className="searcher-input" placeholder="Wyszukaj klienta" style={({height: "20px", padding: "7px", width: "100%", outline: "none", fontWeight: "bold", backgroundColor: "rgb(0,0,0,0)", color: "rgb(70,70,70)", fontSize: "12px", borderRadius: "5px", paddingLeft: "35px", border: "1px solid rgb(30,30,30,0.25)"})} onChange={(e) => setSearcher(e?.target?.value)}/>
              <img src="searcher-blue.png" style={({width: "15px", position: "absolute", top: "11px", left: '3%'})} />
            </div>
            <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", width: "400px", gap: "10px"})}>
              <select className='searcher' value={actualGroup} onChange={(e) => setActualGroup(e.target.value)} style={({height: "37.5px", padding: "7px", maxWidth: "320px", outline: "none", fontWeight: "bold", backgroundColor: "rgb(0,0,0,0)", border: "1px solid rgb(30,30,30,0.25)", color: "rgb(100,100,100)", fontSize: "12px", borderRadius: "5px"})}>
                <option value={""} key={-1}>Wybierz grupę</option>
                {(groups && locations) && Object?.values(groups)?.sort((a, b) => { const nameA = locations?.filter(x => x?.id === a?.location_id)[0]?.name; const nameB = locations?.filter(x => x?.id === b?.location_id)[0]?.name; return nameA.localeCompare(nameB)})?.map((group, index) => (
                  <option value={group?.id} key={index}>{locations?.filter(x => x?.id === group?.location_id)[0]?.name} - {group?.days[0]?.custom_name ? group?.days[0]?.custom_name : numberToPolishWeekday(group?.days[0]?.weekDay) + " - " + group?.days[0]?.startTime + " - " + group?.days[0]?.endTime + " - " + group?.type}</option>
                ))}
              </select>
              {/* <select className='searcher' value={actualGroup} onChange={(e) => setActualGroup(e.target.value)} style={({height: "37.5px", padding: "7px", maxWidth: "320px", outline: "none", fontWeight: "bold", backgroundColor: "rgb(0,0,0,0)", border: "1px solid rgb(30,30,30,0.25)", color: "rgb(100,100,100)", fontSize: "12px", borderRadius: "5px"})}>
                <option value={""} key={-1}>Wybierz grupę</option>
                {(groups && locations) && Object?.values(groups)?.map((group, index) => (
                  <option value={group?.id} key={index}>{locations?.filter(x => x?.id === group?.location_id)[0]?.name} - {group?.days[0]?.custom_name ? group?.days[0]?.custom_name : numberToPolishWeekday(group?.days[0]?.weekDay) + " - " + group?.days[0]?.startTime + " - " + group?.days[0]?.endTime + " - " + group?.type}</option>
                ))}
              </select> */}
              <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "20px", width: "20px", borderRadius: "5px", backgroundColor: filter ? "#0045C7" : "rgb(0,0,0,0)", padding: "6px", border: "2px solid #0045C7", transition: "0.6s"})} onClick={() => setFilter(!filter)}>
                <img src={filter ? "filter.png" : "filter_blue.png"} style={({width: "24px"})} />
              </div>
            </div>
          </div>
          {filter && 
            <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", position: "absolute", bottom: "-210px", right: "0", width: "300px", padding: "10px", backgroundColor: "rgb(255,255,255)", border: "1px solid rgb(30,30,30,0.25)", borderRadius: "5px", gap: "10px"})}>
              <h3 style={({color: "rgb(45,45,45)", fontSize: "12px"})}>Filtry:</h3>
              <div style={({display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "10px", paddingLeft: "5px"})}>
                <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "3px", borderRadius: "3px", borderBottom: filter?.whatsapp === "green" ? "5px solid #0045C7" : "5px solid rgb(0,0,0,0)", transition: "0.4s"})}>
                  <WhatsApp wth={"27px"} color="#2e9428" curs={"pointer"} clickFunc={() => setFilter({...filter, whatsapp: filter?.whatsapp === "green" ? "" : "green"})}/>
                </div>
                <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "3px", borderRadius: "3px", borderBottom: filter?.whatsapp === "send" ? "5px solid #0045C7" : "5px solid rgb(0,0,0,0)", transition: "0.4s"})}>
                  <WhatsApp wth={"27px"} color="#e0b531" curs={"pointer"} clickFunc={() => setFilter({...filter, whatsapp: filter?.whatsapp === "send" ? "" : "send"})}/>
                </div>
                <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "3px", borderRadius: "3px", borderBottom: filter?.whatsapp === "no" ? "5px solid #0045C7" : "5px solid rgb(0,0,0,0)", transition: "0.4s"})}>
                  <WhatsApp wth={"27px"} color="#DC143C" curs={"pointer"} clickFunc={() => setFilter({...filter, whatsapp: filter?.whatsapp === "no" ? "" : "no"})}/>
                </div>
                <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "3px", borderBottom: filter?.whatsapp === "empty" ? "5px solid #0045C7" : "5px solid rgb(0,0,0,0)", borderRadius: "3px", transition: "0.4s"})}>
                  <WhatsApp wth={"27px"} color="rgb(30,30,30)" curs={"pointer"} clickFunc={() => setFilter({...filter, whatsapp: filter?.whatsapp === "empty" ? "" : "empty"})}/>
                </div>
              </div>
              <div style={({display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "10px", paddingLeft: "5px"})}>
                <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "3px", borderBottom: filter?.noDocs ? "5px solid #0045C7" : "5px solid rgb(0,0,0,0)", borderRadius: "3px", transition: "0.4s"})}>
                  <Document wth={"20px"} color={"#DC143C"} clickFunc={() => setFilter({...filter, noDocs: !filter?.noDocs})}/>
                </div>
              </div>
            </div>
          }
          </div>
          {users &&
            <div style={({display: "flex", flexDirection: "row", justifyContent: "space-around", alignItems: "center", border: "1px solid rgb(30,30,30,0.25)", padding: "15px 20px", width: "87.5%", height: "30px", borderRadius: "5px", marginBottom: "5px"})}>
              <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"})}>
                <h3 style={({fontSize: "14px", color: "rgb(30,30,30)"})}>{userList()?.length}</h3>
                <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.6)"})}>Ilość uczestników</h3>
              </div>

              <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"})}>
                <h3 style={({fontSize: "14px", color: "rgb(30,30,30)"})}>{cityCounts["Wrocław"] || 0}</h3>
                <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.6)"})}>Wrocław</h3>
              </div>

              <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"})}>
                <h3 style={({fontSize: "14px", color: "rgb(30,30,30)"})}>{cityCounts["Oława"] || 0}</h3>
                <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.6)"})}>Oława</h3>
              </div>

              <div style={({display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"})}>
                <h3 style={({fontSize: "14px", color: "rgb(30,30,30)"})}>{cityCounts["Jastrzębie"] || 0}</h3>
                <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.6)"})}>Jastrzębie</h3>
              </div>
            </div>
          }
          {users &&
              userList()
          }
          {users && <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.6)"})}>Ilość wyników: {userList()?.length}</h3>}
        </div>
      </div>
    );
  }

  // data podpisu umowy
  // placówka uczestnika
  // dane rodzica - adres, data urodzenia
  // adres uzytkownika
  // podpisane dokumenty i ich rodzaj
  // cena miesieczna
  // ilosc grup
  // grupy uczestnika
  // toVerificate


  // weryfikacja konta
  // usuniecie pustego podpisu
  // zmiana sumy w umowie i reset podpisu
  // zmiana danych
  // zmiana grup
  // dodanie wypowiedzenia
  // usuniecie konta